import { AfterViewChecked, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { v4 as uuid } from 'uuid';
import { Boleto } from '../models/Boleto';
import { MyHttpGetService } from '../services/http.services.token';
import { LocalstorageService } from '../services/localstorage.service';
import { SessionstorageService } from '../services/sessionstorage.service';
import { TimerService } from '../timer/timer.service';
import { Leads } from '../models/Leads';
import { DatosCompradorService } from '../datos-comprador/services/datos-comprador.service';
import { PaymentSource } from '../models/PaymentSource';
import { SeguimientoService } from '../services/seguimiento.service';
import { ModoLigaApp } from '../services/modo-liga-app';
import { MetodosLigaColaborador } from '../services/metodos-liga-colaborador';
import { BoletoComprador, CrearOxxoIntentResponse, CrearSpeiIntentResponse, StripePagoService } from '../services/stripe-pago.service';
declare var $: any;

(<any>window).$ = $;
// para uso de paypal, banamex, stripe y popup
declare var paypal, Checkout, Stripe, window: any;
var datosbol, Urlp, Urlc, popC, spin, Tcomprador, UrlBanamex, ordenbanamex, btn_banamex, UrlExtiendeCarrito, clavesCarrito, timerSvc: any;

@Component({
  selector: 'app-forma-pago',
  templateUrl: './forma-pago.component.html',
  styleUrls: ['./forma-pago.component.scss'],
  providers: [MyHttpGetService, LocalstorageService],
})
export class FormaPagoComponent implements OnInit, AfterViewChecked, OnDestroy {
  //tipos_pago -> Metodos de pago a mostrar según el tipo de sesión (1 -> PublicoGeneral, 2 -> Colaborador desde APP, 3 -> Colaborador desde PC)

  /////////////////////////

  formFormaPago: FormGroup;
  public boletos: Array<Boleto> = [];
  public boletos_asignados: Array<Object> = [];
  public boletos_log: {
    pk1: string;
    boletos: Array<Object>;
    folio: string;
    email: string;
    amount: string;
    nombre: string;
    apellidos: string;
    telefono: string;
    boletos_string: string;
    tipo_comprador: number;
    referencia: string;
  } = {
      pk1: '',
      boletos: [],
      folio: '',
      email: '',
      amount: '',
      nombre: '',
      apellidos: '',
      telefono: '',
      boletos_string: '',
      tipo_comprador: 3,
      referencia: '',
    };
  public boletos_preAsignados: { boletos: Array<Boleto>; confirmacion: string; correo: string; folio: string } = {
    boletos: [],
    confirmacion: '',
    correo: '',
    folio: '',
  };
  public total_compra: number = 0;
  public metodo_pago: number = 1;
  public metodoElegido: boolean = false;
  // Elegir una card (metodoElegido) ya NO genera la orden: el comprador puede cambiar de
  // opción las veces que quiera. pagoIniciado se prende SOLO cuando presiona el botón de
  // continuar (continuarConMetodo); a partir de ahí se genera folio/intent y se bloquea el cambio.
  public pagoIniciado: boolean = false;
  // Textos del resumen "Paso 2": una línea corta de qué va a pasar y el verbo del botón.
  // Pensado para compradores con poca experiencia en compras en línea.
  public readonly INFO_METODOS: { [metodo: number]: { nombre: string; icono: string; boton: string; nota: string } } = {
    6: { nombre: 'Tarjeta de crédito o débito', icono: 'fa-credit-card', boton: 'Continuar al pago con tarjeta',
         nota: 'Escribes los datos de tu tarjeta aquí mismo.' },
    7: { nombre: 'Efectivo en OXXO', icono: 'fa-barcode', boton: 'Generar mi ficha OXXO',
         nota: 'Te damos una ficha para pagar en cualquier OXXO.' },
    8: { nombre: 'Transferencia SPEI', icono: 'fa-exchange', boton: 'Generar datos para transferir',
         nota: 'Te damos una CLABE para transferir desde tu banco.' },
    1: { nombre: 'Tarjeta bancaria', icono: 'fa-credit-card', boton: 'Ir a pagar',
         nota: 'Te llevamos a la página segura del banco.' },
    3: { nombre: 'PayPal', icono: 'fa-paypal', boton: 'Continuar con PayPal',
         nota: 'Pagas con tu cuenta de PayPal.' },
    2: { nombre: 'Depósito bancario', icono: 'fa-university', boton: 'Generar mi referencia',
         nota: 'Te damos una referencia para pagar en Santander.' },
  };
  public stripeFormularioCargado: boolean = false;
  public tipos_pago: number = 1;
  public valida: boolean = false;
  public folio: string = '0';
  public referenciaBanco: string = '0';
  public convenio: string = '0';
  public clabe: string = '0';
  public cuenta: string = '0';
  public procesando: number = 0;
  public tipo_comprador: number = 3;
  public mostrarReferencia: boolean = false;
  public correo: string = ''; // correo con el que se inicio sesion.
  public correo_adicional: string = ''; // correo con el que se inicio sesion.
  // Datos del comprador resueltos en el servidor para el flujo de app (boleto ya rotulado,
  // comprador ya ligado en BD). Los devuelve api/BoletosWeb/Preventa en PreventaReferencia.
  public appCompradorNombre: string = '';
  public appCompradorCorreo: string = '';
  public datos: {
    boletos: Array<Boleto>;
    referencia: string;
    folio: string;
    convenio: string;
    clabe: string;
    cuenta: string;
    correo: string;
    fecha: string;
    colaborador: boolean;
  } = {
      boletos: [],
      referencia: '',
      folio: '',
      convenio: '',
      clabe: '',
      correo: '',
      fecha: '',
      colaborador: false,
      cuenta: '',
    };
  public urlWebPay: { cd_response: string; nb_response: string; nb_url: SafeResourceUrl } = {
    cd_response: '',
    nb_response: '',
    nb_url: '',
  };
  public enviando: boolean = false;
  public envioTexto: string = '';
  public Paybackref: string;
  public pkcolab: string;
  public BoletosCol: string;
  // Flags de métodos parametrizados desde api/payments/metodos-pago.
  // Arrancan en false para no mostrar NINGÚN método mientras carga el spinner;
  // cargarMetodosPago() los enciende según la respuesta del microservicio.
  public habilitarReferencia: boolean = false;
  public habilitaPaypal: boolean = false;
  public habilitaMit: boolean = false;
  public habilitaStripe: boolean = false;
  public habilitaOxxo: boolean = false;
  public habilitaSpei: boolean = false;
  public spinhandler: number = 0;
  cargando = false;
  // Aviso del guard anti-pago-doble (venta digital): se llena cuando el backend responde
  // que el boleto ya tiene una referencia/OXXO/SPEI activa por otro método.
  public bloqueoPagoMsg: string = '';

  // Límite máximo por transacción (lo decide APIs Pagos; ver elegirMetodo).
  private foliosLimite: string[] = [];
  private validandoLimite: boolean = false;
  public modalLimite: boolean = false;
  public limiteMontoMaximo: number = 0;

  // -------- Stripe ------------------
  public addScriptStripe: boolean = false;
  public stripeErrorMsg: string = '';
  private stripeCliente: any;
  private stripeElements: any;
  private stripePaymentIntentId: string;
  // Límite de intentos fallidos en el formulario de tarjeta. Al alcanzarlo, se saca al usuario
  // a error-pago para evitar reintentos infinitos (posible tarjeta robada / fuerza bruta).
  private stripeIntentos: number = 0;
  private readonly STRIPE_MAX_INTENTOS: number = 3;

  // -------- OXXO ------------------
  public addScriptOxxo: boolean = false;
  public oxxoVoucher: CrearOxxoIntentResponse | null = null;
  public oxxoErrorMsg: string = '';
  public oxxoListo: boolean = false;

  // -------- SPEI ------------------
  public addScriptSpei: boolean = false;
  public speiVoucher: CrearSpeiIntentResponse | null = null;
  public speiErrorMsg: string = '';
  public speiListo: boolean = false;

  constructor(
    private domSanitizer: DomSanitizer,
    private myGetService: MyHttpGetService,
    private route: ActivatedRoute,
    private router: Router,
    public st: TimerService,
    private _local: LocalstorageService,
    private _session: SessionstorageService,
    private fb: FormBuilder,
    private _DCompradorService: DatosCompradorService,
    private readonly _seguimiento: SeguimientoService,
    private readonly _stripePagoService: StripePagoService
  ) {
    this.correo = this._session.getCorreoComp();
    var lsApartados = this._local.getBoletosApartados();
    var lsAsignados = this._local.getBoletosAsignados();
    this.boletos = lsApartados == null ? [] : JSON.parse(lsApartados);
    ////console.log(lsApartados);
    ////console.log(lsAsignados);
    ////console.log(this.boletos);
    this.boletos_preAsignados.boletos = lsAsignados == null ? [] : JSON.parse(lsAsignados);
    this.tipo_comprador = this._session.getTipoAsignado() ? parseInt(this._session.getTipoAsignado()) : 3;

    this.route.queryParams.subscribe((params) => {
      this.folio = params.ordencompra == undefined ? '0' : params.ordencompra;
    });
    //////console.log(this.folio);

    this.tipos_pago = parseInt(this._session.getTiposPago());

    this.formFormaPago = this.fb.group({
      nombre_titular: ['', Validators.pattern(/[a-zA-Z������������\s]/)],
      no_tarjeta: ['', Validators.pattern(/^\d*$/)],
      vence_mes: ['', Validators.pattern(/^\d*$/)],
      vence_anio: ['', Validators.pattern(/^\d*$/)],
      codigo_seg: ['', Validators.pattern(/^\d*$/)],
    });
    //#region Validacion Referencia Banc Activa
    this.BoletosCol = this._session.getBoletosCol() ? this._session.getBoletosCol() : '0';
    this.Paybackref = this._local.getPaybackref() ? this._local.getPaybackref() : '0';
    this.pkcolab = this._local.getPKColab() ? this._local.getPKColab() : '0';
    //#endregion
  }

  async ngOnInit() {
    /*INSERTAR LOG CUANDO SE PASE DIRECTO A FORMA DE PAGO */
    ////console.log(this.boletos_preAsignados.boletos);
    ////console.log(this.tipo_comprador);
    /////console.log();

    /* */
    // let noshow = localStorage.getItem('noShow');
    //if(noshow != 'true') {  this.showConfirm(); }

    // Sin boletos no hay nada que pagar: se limpia la compra y se regresa al home, en vez de
    // dejar los métodos de pago en pantalla con un carrito vacío.
    if (this.sinBoletos) {
      this.terminar();
      this._local.deleteFolio();
      this.router.navigate(['compra-en-linea-boletos-sorteo-anahuac']);
      return;
    }

    spin = document.getElementById('spin');
    spin.hidden = false;

    /// Pop up	& Paypal
    popC = this._session.getPopstate();
    //////console.log(popC);
    //this.PopupAmigable(popC);
    Urlp = this.myGetService.getInfoOrden('api/BoletosWeb/PagoPayPalSDK');
    Urlc = this.myGetService.getInfoOrden('api/BoletosWeb/PagoPayPalConfirmado');
    UrlBanamex = this.myGetService.getInfoOrden('api/BoletosWeb/PagoBanamex');
    UrlExtiendeCarrito = this.myGetService.getInfoOrden('api/BoletosWeb/ExtiendeCarrito');
    timerSvc = this.st;
    Tcomprador = this.tipo_comprador;
    /// Pop up & Paypal

    if (this.tipos_pago == 1) {
      this.st.startTimer();
    }

    this.procesando = 0;
    if (this.tipos_pago == 1) {
      this.getTotalCompra(this.boletos);
    } else {
      this.getTotalCompra(this.boletos_preAsignados.boletos);
    }

    if (this.folio != '0') {
      this.efectuarPagoPublicoGeneral();
    }

    // history.pushState(null,null, 'forma-pago');
    // window.addEventListener('popstate', function(event) {
    // 	history.pushState(null,null, 'forma-pago');
    // 	////console.log(this.history.length);
    // })
    //////console.log("tipo comprador");
    //////console.log(this.tipo_comprador);
    if (this.tipo_comprador == 3) {
      if (this.tipos_pago >= 2) {
      } else {
        history.pushState(null, null, 'forma-pago');
        window.addEventListener('popstate', function (event) {
          history.replaceState(null, null, 'compra-en-linea-boletos-sorteo-anahuac');
          history.pushState(null, null, 'compra-en-linea-boletos-sorteo-anahuac');
          history.go(0);
        });
      }
    }
    if (this._local.getFolio()) {
      //////console.log("Si tiene folio");
      if (this.tipo_comprador == 3) {
        if (this.tipos_pago >= 2) {
        } else {
          this._local.deleteBoletosGenerados();
          this._local.deleteBoletosRecomendados();
          this._local.deleteBoletosAsignados();
    // Se conserva la liga de colaborador: el comprador debe poder volver a sus boletos.
          this._local.limpiarCompra();
          this._local.deleteFolio();
          this.router.navigate(['compra-en-linea-boletos-sorteo-anahuac']);
        }
      }
      // if (this.tipo_comprador == 1 || this.tipo_comprador == 2) {
      // this.router.navigate(["login"]);
      //	this.router.navigate(["compra-en-linea-boletos-sorteo-anahuac"]);
      // } else {
      // 	this.router.navigate(["compra-en-linea-boletos-sorteo-anahuac"]);
      // }
    }
    //ordenbanamex = false;
    // Resuelve qué métodos de pago mostrar consultando la configuración parametrizada
    // (ConfiguracionMetodosDePago) vía el microservicio de pagos. Reemplaza a
    // GetMetodoParametrizado() + RefBancStatus() (que quedan como referencia, ya sin uso).
    await this.cargarMetodosPago();


    /**/
    let ctnMit = document.getElementById("content-mit");
    let ctnPay = document.getElementById("content-pay");
    let ctnRef = document.getElementById("content-ref");
    let ctnStripe = document.getElementById("content-stripe");
    let ctnOxxo = document.getElementById("content-oxxo");
    let ctnSpei = document.getElementById("content-spei");
    let ctaMorePay = document.getElementById("ctaMorePay");
    ctaMorePay.style.display = "none";

    let btnMit = document.getElementById("FormaMIT");
    let btnPay = document.getElementById("FormaPaypal");
    let btnRef = document.getElementById("FormaDeposito");
    let btnStripe = document.getElementById("FormaStripe");
    let btnOxxo = document.getElementById("FormaOxxo");
    let btnSpei = document.getElementById("FormaSpei");

    btnMit.addEventListener("click", function () {
      if (ctnPay) ctnPay.style.display = "none";
      if (ctnRef) ctnRef.style.display = "none";
      if (ctnStripe) ctnStripe.style.display = "none";
      if (ctnOxxo) ctnOxxo.style.display = "none";
      if (ctnSpei) ctnSpei.style.display = "none";
      ctaMorePay.style.display = "block";

      (<any>$('#modalRedirigir')).modal('show');
      setTimeout(function () {
        ($('#modalRedirigir')).modal('hide');
      }, 3000);

    });

    if (btnPay) btnPay.addEventListener("click", function () {
      ctnMit.style.display = "none";
      if (ctnRef) ctnRef.style.display = "none";
      if (ctnStripe) ctnStripe.style.display = "none";
      if (ctnOxxo) ctnOxxo.style.display = "none";
      if (ctnSpei) ctnSpei.style.display = "none";
    });

    if (btnRef) btnRef.addEventListener("click", function () {
      ctnMit.style.display = "none";
      if (ctnPay) ctnPay.style.display = "none";
      if (ctnStripe) ctnStripe.style.display = "none";
      if (ctnOxxo) ctnOxxo.style.display = "none";
      if (ctnSpei) ctnSpei.style.display = "none";
      ctaMorePay.style.display = "block";
    });

    if (btnStripe) btnStripe.addEventListener("click", function () {
      ctnMit.style.display = "none";
      if (ctnPay) ctnPay.style.display = "none";
      if (ctnRef) ctnRef.style.display = "none";
      if (ctnOxxo) ctnOxxo.style.display = "none";
      if (ctnSpei) ctnSpei.style.display = "none";
      ctaMorePay.style.display = "block";
    });

    if (btnOxxo) btnOxxo.addEventListener("click", function () {
      ctnMit.style.display = "none";
      if (ctnPay) ctnPay.style.display = "none";
      if (ctnRef) ctnRef.style.display = "none";
      if (ctnStripe) ctnStripe.style.display = "none";
      if (ctnSpei) ctnSpei.style.display = "none";
      ctaMorePay.style.display = "block";
    });

    if (btnSpei) btnSpei.addEventListener("click", function () {
      ctnMit.style.display = "none";
      if (ctnPay) ctnPay.style.display = "none";
      if (ctnRef) ctnRef.style.display = "none";
      if (ctnStripe) ctnStripe.style.display = "none";
      if (ctnOxxo) ctnOxxo.style.display = "none";
      ctaMorePay.style.display = "block";
    });

    const btnPagarMit = document.querySelector("body > app-root > app-layout > app-forma-pago > section.section-payment > div > div > div.col-xs-12.col-sm-12.col-md-12.col-lg-12.col-xl-12 > div.col-12.margen-t.mrg > button");
    if (btnPagarMit) btnPagarMit.addEventListener("click", function () {
      (<any>$('#modalRedirigir')).modal('show');
      setTimeout(function () {
        ($('#modalRedirigir')).modal('hide');
      }, 1000);
    });

    /**/

  }

  showConfirm() {
    (window as any).alertify
      .confirm('IMPORTANTE',
        `<div class="custom-confirm">
          <p>Por favor, considera los siguientes puntos:</p>
            <ul>
            
              <li>En este momento, tu boleto se encuentra en el carrito. En caso de que salgas de la pantalla, actualices la página, cierres el navegador o experimentes un error durante el pago, tendrás que esperar 15 minutos antes de volver a intentar la compra por el mismo número.</li>
             
              <li>Si generas una referencia bancaria, tu boleto quedará reservado durante 5 días hábiles. No podrás pagar con otro método de pago hasta que el boleto se libere.</li>

              <li> Si vas a pagar con tarjeta de débito, se recomienda hacerlo con tu tarjeta digital.</li>

            </ul>

            
            <p>
                <strong>Siguiendo estas recomendaciones podrás evitar problemas y asegurarte de que tu compra se procese sin inconvenientes. Si sigues los pasos correctamente, el proceso de pago será más fluido y sin complicaciones.</strong>
            </p>
        </div>`,
        () => {
          (window as any).alertify.success('¡LO TENGO!');

        },
        () => {
          // Esta función puede estar vacía si no necesitas manejar el clic en Cancelar
          localStorage.setItem('noShow', 'true');
        }
      )
      .set('labels', { ok: 'He leído', cancel: 'No mostar más' })  // Etiqueta vacía para el botón Cancelar
      .set('closable', false)  // Evitar cerrar la ventana al hacer clic fuera de ella
      .set('defaultFocus', 'ok')  // Definir el enfoque por defecto
      .set('className', 'custom-confirm');  // Aplicar la clase CSS personalizada
  }

  showMethod() {
    let ctaMorePay = document.getElementById("ctaMorePay");
    ctaMorePay.style.display = "none";
    const ids = ["content-mit", "content-pay", "content-ref", "content-stripe", "content-oxxo", "content-spei"];
    ids.forEach(id => { const el = document.getElementById(id); if (el) el.style.display = "block"; });
  }

  getTotalCompra(boletos: Array<Boleto>) {
    if (boletos !== []) {
      for (var i = 0; i <= boletos.length - 1; i++) {
        this.total_compra = this.total_compra + boletos[i].costo;
      }
    }
  }

  async efectuarPagoPublicoGeneral() {

    var btnpay = document.getElementById('paypal-button-container');
    if (btnpay) btnpay.hidden = true;
    spin = document.getElementById('spin');
    spin.hidden = true;

    if (this.metodo_pago == 1 || this.metodo_pago == 2) {
      spin.hidden = false;
    }

    this.boletos_asignados = [];

    this.boletos.forEach(
      function (Item) {
        this.boletos_asignados.push({
          comprador: {
            direccion: {
              telefono: Item.comprador.telefono_fijo,
              municipio: Item.comprador.municipio,
              estado: Item.comprador.estado,
              codigo_postal: Item.comprador.codigo_postal,
              colonia: Item.comprador.colonia,
              numero: Item.comprador.numero,
              calle: Item.comprador.calle,

            },
            nombre_completo: Item.comprador.nombre + ' ' + Item.comprador.apellidos,
            celular: Item.comprador.telefono_movil,
            correo: Item.comprador.correo_electronico,
            correo_alternativo: Item.comprador.correo_alternativo,
            correo_tarjetahabiente: Item.comprador.correo_tarjetahabiente,
            apellidos: Item.comprador.apellidos,
            apellido_paterno: Item.comprador.apellido_paterno,
            apellido_materno: Item.comprador.apellido_materno,
            egresado: Item.comprador.egresado,
            campus: Item.comprador.campus,
            nombre: Item.comprador.nombre,
            pkcanal: Item.comprador.pkcanal,
            especifica_canal: Item.comprador.especifica_canal,
            pais: Item.comprador.pais,
            dia: Item.comprador.dia,
            mes: Item.comprador.mes,
            anio: Item.comprador.anio,
            pk_comprador_existente: Item.comprador.pk_comprador_existente
          },
          folio_talonario: Item.folio_talonario,
          folio: Item.folio,
          clave: Item.clave.toString(),
        });
        this.boletos_log.boletos.push({
          folio_talonario: Item.folio_talonario,
          folio: Item.folio,
          clave: Item.clave.toString(),
        });
      }.bind(this)
    );
    //////console.log( this.boletos_asignados);
    this.boletos_log.nombre = this.boletos[0].comprador.nombre;
    this.boletos_log.apellidos = this.boletos[0].comprador.apellidos;
    this.boletos_log.email = this.boletos[0].comprador.correo_electronico;
    this.boletos_log.telefono = this.boletos[0].comprador.telefono_movil;
    this.boletos_log.pk1 = uuid();
    this.boletos_log.tipo_comprador = this._session.getBoletosCol() == '1' ? 4 : 3;
    /* aqui se crea el comprador y se tra referencia y todos los datos pero aun no se hace la compra */
    ////console.log(this.boletos_asignados);
    ////console.log("respuesta");
    /* */
    //console.log(this.folio);
    if (this.folio != '0') {
      window.location.href = 'error-pago?success=false&nbResponse=ErrorDatosCarrito';
    } else {
      // Candado anti-carrera: bloquea la liberación por timer/modal ANTES de disparar la
      // generación del folio, para que no se libere el boleto justo cuando se está generando.
      this.st.pagoEnProceso = true;
      this.st.resetModal();
      return new Promise((resolve, reject) => {
        //console.log(this.boletos_asignados);
        this.myGetService
          .postData(this.boletos_asignados, 'api/BoletosWeb/PreventaPublicoGeneralBanco/' + this.metodo_pago)
          .subscribe((res) => {

            //console.log(res);

            let obj = res.json();

            // Guard anti-pago-doble (contrato con PreventaPublicoGeneralBanco, solo venta digital):
            // si algún boleto ya tiene una referencia/OXXO/SPEI activa por OTRO método, el backend
            // responde bloqueo. Reutilización del MISMO método viene como respuesta normal (con su folio).
            if (obj && (obj.error === 2 || obj.message === 'PAGO_ACTIVO')) {
              this.bloqueoPagoMsg = 'Ya tienes un pago activo (referencia, OXXO o SPEI) para uno o más de estos boletos. Espera a que venza o realiza ese pago antes de usar otro método.';
              this.metodo_pago = 0;
              this.metodoElegido = false;
              this.pagoIniciado = false;
              this.addScript = false;
              this.addScriptStripe = false;
              this.addScriptOxxo = false;
              this.addScriptSpei = false;
              this.st.pagoEnProceso = false;
              if (spin) spin.hidden = true;
              this.procesando = 0;
              resolve('pago activo bloqueado');
              return;
            }

            this.folio = obj.folio;
            this.referenciaBanco = obj.referencia;
            this.convenio = obj.convenio;
            this.clabe = obj.clabe;
            this.cuenta = obj.cuenta;
            this.boletos_log.folio = this.folio;
            this.boletos_log.amount = this.total_compra.toString();
            this.boletos_log.boletos_string = JSON.stringify(this.boletos_log.boletos);
            this._local.setFolio(this.folio);
            /* crear localstorage boletos*/
            localStorage.setItem("boletosAparatadosTem", sessionStorage.getItem('BoletosApartados'));
            if (this.folio == '0' || !this.folio) {
              window.location.href = 'error-pago?success=false&nbResponse=ErrorDatosCarrito';
            } else {
              //aqui llama function para pago al banco

              this.myGetService.postData(this.boletos_log, 'api/BoletosWeb/VentaLog').subscribe((res) => {
                ////console.log(res);
              });

              if (this.metodo_pago == 2) {
                this.datos.folio = this.folio;
                this.datos.referencia = this.referenciaBanco;
                this.datos.convenio = this.convenio;
                this.datos.clabe = this.clabe;
                this.datos.cuenta = this.cuenta;
                this.datos.boletos = this.boletos;
                //console.log( "BOLETOS" );
                //console.log( this.datos.boletos);
                this.datos.correo = this.boletos_log.email;
                this.mostrarReferencia = true;
                this.st.pagoEnProceso = true;
                spin.hidden = true;
                this.myGetService.postData(this.datos, 'api/BoletosWeb/ReenvioReferencia').subscribe((res) => {
                  //////console.log(res);
                });

                this.myGetService.postData(this.datos, 'api/BoletosWeb/EnviarRecordatorio').subscribe((res) => {
                  //////console.log(res);
                });

                var correoalt = this.boletos[0].comprador.correo_alternativo;

                if (correoalt) {
                  this.datos.correo = this.boletos[0].comprador.correo_alternativo;

                  this.myGetService.postData(this.datos, 'api/BoletosWeb/ReenvioReferencia').subscribe((res) => {
                    //////console.log(res);
                  });
                }

                //enviar referencia
                let infoCampania: Leads;
                ////console.log("lead referencia bancaria");
                let temInfo = JSON.parse(localStorage.getItem('campaingData'));
                //localStorage.setItem("first", 'false' );
                ////console.log(temInfo);
                infoCampania = temInfo;
                ////console.log( infoCampania);
                //traer datos de la compra
                let datosComprador = JSON.parse(sessionStorage.getItem('BoletosApartados'));
                ////console.log(datosComprador);
                let numBoletos = infoCampania.boletos_seleccionados.split(",");

                //añadir nuevo correo 
                /* datos comprador */
                infoCampania.correo = datosComprador[0].comprador.correo_electronico;
                infoCampania.sorteo = 8;
                infoCampania.nombre = datosComprador[0].comprador.nombre;

                infoCampania.apellido_peterno = datosComprador[0].comprador.apellido_paterno;
                infoCampania.apellido_materno = datosComprador[0].comprador.apellido_materno;
                infoCampania.telefono = datosComprador[0].comprador.telefono_fijo;
                infoCampania.celular = datosComprador[0].comprador.telefono_movil;
                infoCampania.num_boletos_comprados = numBoletos.length;
                infoCampania.monto = 500 * numBoletos.length;
                infoCampania.estatus_pago = "REFERENCIA-" + this.datos.referencia;
                infoCampania.boletos_seleccionados = "";
                ////console.log(datosComprador);
                ////console.log(infoCampania);
                let dataCampania: Leads = infoCampania;
                this._DCompradorService.modificaLeads(dataCampania).subscribe(a => {
                  ////console.log(a);


                },
                  err => {
                    ////console.log(err);
                    if (err.status == 200) {
                      ////console.log("entre2 REFERENCIA");
                      localStorage.removeItem("InfoCompania");
                      localStorage.removeItem("campaingData");
                      localStorage.setItem("leads", "false");
                      let organico = "?utm_source=organico&utm_medium=organico&utm_campaign=organico&utm_term=organico&utm_content=organico";
                      let utm2 = organico.split("?");
                      var search2 = utm2[1];
                      ////console.log(JSON.stringify(organico));
                      let finalUtm = JSON.parse('{"' + search2.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) { return key === "" ? value : decodeURIComponent(value) });
                      //////console.log(finalUtm);
                      localStorage.setItem('campaingData', JSON.stringify(finalUtm));

                      ////console.log(localStorage.getItem('leads'));
                      ////console.log(dataCampania);
                    }
                  });

                //add seguimiento
                sessionStorage.setItem('metodoPago', 'REFERENCIA');
                sessionStorage.setItem('ordenDeCompra', "REFERENCIA - " + this.datos.referencia);
                let respuesta;
                let tipoP = sessionStorage.getItem('TiposPago');
                let tipoPInt = parseInt(tipoP, 10)
                if (tipoPInt == 2 || tipoPInt == 3) {
                  sessionStorage.setItem('paginaclick', '/forma-pago - directo');
                  this._seguimiento.addSeguimiento(JSON.parse(sessionStorage.getItem('BoletosAsignados'))).subscribe(a => {
                    //console.log(a);
                    respuesta = a;
                    const pk_seguimiento = respuesta.pk1;
                    //console.log(pk_seguimiento);
                    sessionStorage.setItem('pk_seguimiento', pk_seguimiento);
                  },
                    err => {

                    });
                } else {
                  //updatear cuando ya esta creado el seguimiento
                  sessionStorage.setItem('paginaclick', '/forma-pago');
                  this._seguimiento.updateSeguimiento().subscribe(a => {
                    //console.log(a);
                  },
                    err => {

                    });
                }
                //this.myGetService.postData(this.datos, "api/BoletosWeb/ReenviarRecordatorio").subscribe((res) => {
                //	////console.log(res);
                //});
                this.terminar();
              } else if (this.metodo_pago == 1) {
                this.extiendeCarrito(1);
                this.st.iniciarPago(environment.extiendeCarritoMinutos);
                this.procesando = 1;
                //MIT pago
                localStorage.setItem('campaingData1', localStorage.getItem("campaingData"));
                let respuesta;
                sessionStorage.setItem('metodoPago', 'MIT');
                sessionStorage.setItem('ordenDeCompra', this.folio);
                //console.log("this.tipos_pago" + this.tipos_pago);
                let tipoP = sessionStorage.getItem('TiposPago');
                let tipoPInt = parseInt(tipoP, 10)
                if (tipoPInt == 2 || tipoPInt == 3) {
                  //console.log("efectuarPagoPublicoGeneral insert");
                  sessionStorage.setItem('paginaclick', '/forma-pago - directo');
                  this._seguimiento.addSeguimiento(JSON.parse(sessionStorage.getItem('BoletosAsignados'))).subscribe(a => {
                    //console.log(a);
                    respuesta = a;
                    const pk_seguimiento = respuesta.pk1;
                    //console.log(pk_seguimiento);
                    sessionStorage.setItem('pk_seguimiento', pk_seguimiento);
                  },
                    err => {

                    });
                } else {
                  //updatear cuando ya esta creado el seguimiento
                  sessionStorage.setItem('paginaclick', '/forma-pago');
                  //console.log("efectuarPagoPublicoGeneral update");
                  this._seguimiento.updateSeguimiento().subscribe(a => {
                    //console.log(a);
                  },
                    err => {

                    });
                }

                //orden de compra generada
                this.myGetService.getLigaWebPay('api/BoletosWeb/PagoWPP2', this.folio).subscribe((res) => {
                  this.urlWebPay.cd_response = res.json().cd_response;
                  this.urlWebPay.nb_response = res.json().nb_response;
                  ////console.log( this.urlWebPay);
                  ////console.log( res);
                  //corregir aqui
                  //window.open(res.json().nb_url, '_blank');
                  window.location.href = res.json().nb_url;
                },
                  err => {
                    //console.log(err);
                  });
              } else if (this.metodo_pago == 6) {
                //Stripe: el folio/VentaLog ya quedaron registrados arriba; el cobro lo hace StripePagoService.
                // El usuario se queda EN la página llenando la tarjeta: mantener el contador VISIBLE y
                // extender la reserva +extiendeCarritoMinutos en front y BD (BOLETOS.Carrito + tabla CARRITO).
                // Si abandona y se agota el tiempo, el boleto se libera (liberarConFolio=true).
                this.extiendeCarrito(6);
                this.st.extenderVisible(environment.extiendeCarritoMinutos);
                localStorage.setItem('campaingData1', localStorage.getItem("campaingData"));
                let respuesta;
                sessionStorage.setItem('metodoPago', 'STRIPE');
                sessionStorage.setItem('ordenDeCompra', this.folio);
                let tipoP = sessionStorage.getItem('TiposPago');
                let tipoPInt = parseInt(tipoP, 10)
                if (tipoPInt == 2 || tipoPInt == 3) {
                  sessionStorage.setItem('paginaclick', '/forma-pago - directo');
                  this._seguimiento.addSeguimiento(JSON.parse(sessionStorage.getItem('BoletosAsignados'))).subscribe(a => {
                    respuesta = a;
                    const pk_seguimiento = respuesta.pk1;
                    sessionStorage.setItem('pk_seguimiento', pk_seguimiento);
                  },
                    err => {

                    });
                } else {
                  sessionStorage.setItem('paginaclick', '/forma-pago');
                  this._seguimiento.updateSeguimiento().subscribe(a => {
                  },
                    err => {

                    });
                }
              } else {
                //Metodo paypal & Metodo Banamex
                if (this.metodo_pago == 3 || this.metodo_pago == 4) {
                  var datosorden = {
                    folio: this.boletos_log.folio,
                    amount: this.boletos_log.amount,
                    email: this.boletos_log.email,
                  };
                  datosbol = datosorden;
                  this._local.deleteBoletosGenerados();
                  this._local.deleteBoletosRecomendados();
                  this._local.deleteBoletosAsignados();
                  //window.sessionStorage.clear();
                  if (this.metodo_pago == 3) {
                    btnpay.hidden = false;
                    // El folio ya quedó, así que se suelta el candado anti-carrera que puso
                    // efectuarPagoPublicoGeneral (pagoEnProceso = true) y vuelve el contador
                    // a la vista. Con PayPal el usuario NO se va del sitio —paga en una
                    // ventana emergente— así que debe seguir viendo cuánto tiempo le queda,
                    // igual que con Stripe. Sin esto el contador desaparece al elegir PayPal.
                    this.st.extenderVisible(environment.extiendeCarritoMinutos);
                  }
                  //return (datosorden);
                }
              }
            }
            if (this.metodo_pago == 3 || this.metodo_pago == 4) {
              if (datosbol != null || datosbol != undefined) {
                resolve('datosbol listo promise');
              }
            } else {
              resolve('preventa completa');
            }
          }, err => {
            //console.log(err);
            const errorBody = JSON.parse(err._body);

            //console.log(errorBody.error); // Accede a la propiedad `error`
            //console.log(errorBody.message); // Accede a la propiedad `message`
            if (errorBody.error == 1) {
              //guarda el mensaje el pk de seguimiento
              this._seguimiento.updateErrorCaracteres(errorBody.message).subscribe(a => {
                //console.log(a);
              });
              window.location.href = 'error-pago?success=false&nbResponse=ErrorDatos';
            }
          });
      }); //del promise

      ///aqui acaba el post preventa
    }

    this._local.deleteBoletosGenerados();
    this._local.deleteBoletosRecomendados();
    this._local.deleteBoletosAsignados();
    //window.sessionStorage.clear();
  }

  validarBoletosNombre(): Promise<boolean> {
    const boletosRaw = sessionStorage.getItem('BoletosAsignados');
    if (!boletosRaw) return Promise.resolve(false);

    const boletos = JSON.parse(boletosRaw);

    return new Promise((resolve) => {
      this._seguimiento.validarBoletoNombre(boletos).subscribe({
        next: (resultado: any) => {
          if (resultado && resultado.coincide === true) {
            resolve(true);
          } else {
            resolve(false);
          }
        },
        error: () => resolve(false)
      });
    });
  }


  async efectuarPagoAlterno(metodoPago) {
    const esValido = await this.validarBoletosNombre();

    if (!esValido) {
      alert("El comprador ha cambiado de nombre o la información es inválida. Favor de verificar.");
      const modoLigaApp = ModoLigaApp.respaldar();
      sessionStorage.clear();
      ModoLigaApp.restaurar(modoLigaApp);
      localStorage.clear();
      this.router.navigate(['compra-en-linea-boletos-sorteo-anahuac']);
      return Promise.reject('Validación fallida');
    }



    this.procesando = 1;

    var btnpay = document.getElementById('paypal-button-container');
    if (btnpay) btnpay.hidden = true;
    spin = document.getElementById('spin');
    spin.hidden = true;
    if (metodoPago == 2 || metodoPago == 1) {
      spin.hidden = false;
    }
    this.tipo_comprador = this._session.getTipoAsignado() ? parseInt(this._session.getTipoAsignado()) : 3;
    ////console.log(this.tipo_comprador);
    // Candado anti-carrera: bloquea la liberación por timer/modal ANTES de disparar la
    // generación del folio, para que no se libere el boleto justo cuando se está generando.
    this.st.pagoEnProceso = true;
    this.st.resetModal();
    return new Promise((resolve, reject) => {
      //api/BoletosWeb/PagoWPP2/{ordenCompra}
      this.myGetService
        .postData(
          this.boletos_preAsignados.boletos,
          'api/BoletosWeb/Preventa/' + metodoPago + '/' + this.tipo_comprador
        )
        .subscribe((res) => {
          ////console.log(res);

          this.folio = res.json().folio;
          //console.log(this.folio);
          this._local.setFolio(this.folio);
          // El boleto ya está rotulado: el comprador ligado se resuelve en el servidor
          // (PreventaReferencia) y se usa para OXXO/SPEI/tarjeta, ya que en el flujo de
          // app los boletos no traen el objeto .comprador.
          this.appCompradorNombre = res.json().nombre_comprador ?? '';
          this.appCompradorCorreo = res.json().correo_comprador ?? '';
          this.datos.referencia = res.json().referencia;
          this.datos.convenio = res.json().convenio;
          this.datos.clabe = res.json().clabe;
          this.datos.cuenta = res.json().cuenta;

          this.boletos_log.pk1 = uuid();
          this.boletos_log.referencia = res.json().referencia;
          this.boletos_log.tipo_comprador = parseInt(this._session.getTipoAsignado());
          this.boletos_log.folio = res.json().folio;
          this.boletos_log.boletos_string = JSON.stringify(this.boletos_preAsignados.boletos);
          this.boletos_log.amount = this.total_compra.toString();

          var tipo_asig = this._session.getTipoAsignado();

          this.boletos_log.email = tipo_asig == '1' ? this._session.getColab() : this.correo;

          var tipo_asig = this._session.getTipoAsignado();
          //////console.log(this.boletos_preAsignados);
          if (this.folio == '0') {
            window.location.href = 'error-pago?success=false&nbResponse=ErrorDatosCarrito';
          } else {
            this.myGetService.postData(this.boletos_log, 'api/BoletosWeb/VentaLog').subscribe((res) => {
              //////console.log("exitoso");
            });
            //debugger;
            if (metodoPago == 1) {
              let respuesta;
              sessionStorage.setItem('metodoPago', 'MIT');
              sessionStorage.setItem('ordenDeCompra', this.folio);
              let tipoP = sessionStorage.getItem('TiposPago');
              let tipoPInt = parseInt(tipoP, 10)
              if (tipoPInt == 2 || tipoPInt == 3) {
                sessionStorage.setItem('paginaclick', '/forma-pago - directo');
                this._seguimiento.addSeguimiento(JSON.parse(sessionStorage.getItem('BoletosAsignados'))).subscribe(a => {
                  //console.log(a);
                  respuesta = a;
                  const pk_seguimiento = respuesta.pk1;
                  //console.log(pk_seguimiento);
                  sessionStorage.setItem('pk_seguimiento', pk_seguimiento);
                },
                  err => {

                  });
              } else {
                //updatear cuando ya esta creado el seguimiento
                sessionStorage.setItem('paginaclick', '/forma-pago');
                this._seguimiento.updateSeguimiento().subscribe(a => {
                  //console.log(a);
                },
                  err => {

                  });
              }
              this.myGetService.getLigaWebPay('api/BoletosWeb/PagoWPP2', this.folio).subscribe((res) => {
                this.urlWebPay.cd_response = res.json().cd_response;
                this.urlWebPay.nb_response = res.json().nb_response;
                //////console.log(res.json().nb_url);
                window.location.href = res.json().nb_url;
              });
            } else if (metodoPago == 6) {
              //Stripe: el folio/VentaLog ya quedaron registrados arriba; el cobro lo hace StripePagoService.
              localStorage.setItem('campaingData1', localStorage.getItem("campaingData"));
              let respuesta;
              sessionStorage.setItem('metodoPago', 'STRIPE');
              sessionStorage.setItem('ordenDeCompra', this.folio);
              let tipoP = sessionStorage.getItem('TiposPago');
              let tipoPInt = parseInt(tipoP, 10)
              if (tipoPInt == 2 || tipoPInt == 3) {
                sessionStorage.setItem('paginaclick', '/forma-pago - directo');
                this._seguimiento.addSeguimiento(JSON.parse(sessionStorage.getItem('BoletosAsignados'))).subscribe(a => {
                  respuesta = a;
                  const pk_seguimiento = respuesta.pk1;
                  sessionStorage.setItem('pk_seguimiento', pk_seguimiento);
                },
                  err => {

                  });
              } else {
                sessionStorage.setItem('paginaclick', '/forma-pago');
                this._seguimiento.updateSeguimiento().subscribe(a => {
                },
                  err => {

                  });
              }
            } else if (metodoPago == 2) {
              this.datos.folio = this.folio;
              this.datos.boletos = this.boletos_preAsignados.boletos;
              this.datos.correo = this.correo;
              this.datos.colaborador = true;

              //add seguimiento
              sessionStorage.setItem('metodoPago', 'REFERENCIA');
              sessionStorage.setItem('ordenDeCompra', "REFERENCIA - " + this.folio);
              let respuesta;
              let tipoP = sessionStorage.getItem('TiposPago');
              let tipoPInt = parseInt(tipoP, 10)
              if (tipoPInt == 2 || tipoPInt == 3) {
                sessionStorage.setItem('paginaclick', '/forma-pago - directo');
                this._seguimiento.addSeguimiento(JSON.parse(sessionStorage.getItem('BoletosAsignados'))).subscribe(a => {
                  //console.log(a);
                  respuesta = a;
                  const pk_seguimiento = respuesta.pk1;
                  //console.log(pk_seguimiento);
                  sessionStorage.setItem('pk_seguimiento', pk_seguimiento);
                },
                  err => {

                  });
              } else {
                //updatear cuando ya esta creado el seguimiento
                sessionStorage.setItem('paginaclick', '/forma-pago');
                this._seguimiento.updateSeguimiento().subscribe(a => {
                  //console.log(a);
                },
                  err => {

                  });
              }
              //////console.log(this.datos);

              this.myGetService.postData(this.datos, 'api/BoletosWeb/ReenvioReferencia').subscribe((res) => {
                //////console.log(res);
                this.mostrarReferencia = true;
                spin.hidden = true;
              });

              this.myGetService.postData(this.datos, 'api/BoletosWeb/EnviarRecordatorio').subscribe((res) => {
                //////console.log(res);
              });
              this.terminar();
            } else if (metodoPago == 3 || metodoPago == 4) {
              //servicio paypal
              var datosorden = {
                folio: this.boletos_log.folio,
                amount: this.boletos_log.amount,
              };
              datosbol = datosorden;
              if (metodoPago == 3) {
                btnpay.hidden = false;
              }

              //return (datosorden);
            }
          }
          if (this.metodo_pago == 3 || this.metodo_pago == 4) {
            if (datosbol != null || datosbol != undefined) {
              resolve('datosbol listo promise');
            }
          } else {
            resolve('preventa completa');
          }

        }, err => {
          console.error('Error en la llamada a la API de preventa', err);
          reject('Error en la llamada a la API de preventa');
        }); // subscribe
    }); // promise
  }

  reenviarCorreo() {
    this.enviando = true;
    this.datos.boletos =
      this.boletos_preAsignados && this.boletos_preAsignados.boletos.length > 0
        ? this.boletos_preAsignados.boletos
        : this.boletos;
    this.datos.correo = this.correo_adicional; //(this.boletos_preAsignados && this.boletos_preAsignados.boletos.length > 0) ? this.boletos_preAsignados.correo : this.boletos_log.email ;

    //console.log("datos para reenvio");
    //console.log(this.datos);
    this.myGetService.postData(this.datos, 'api/BoletosWeb/ReenvioReferenciaCorreo').subscribe((res) => {
      this.envioTexto = 'Referencia enviada nuevamente';
      setTimeout(() => {
        this.enviando = false;
      }, 3000);
    });
  }

  regresar(): void {
    this.router.navigate(['compra-en-linea-boletos-sorteo-anahuac']);
  }

  terminar(): void {
    this._local.deleteBoletosGenerados();
    this._local.deleteBoletosRecomendados();
    this._local.deleteBoletosAsignados();
    this._local.deleteCarrito();
    // Se conserva la liga de colaborador: el comprador debe poder volver a sus boletos.
    this._local.limpiarCompra();
  }

  //// ------------ POPUP------------
  /*
  PopupAmigable(popC) {
    var PopAct = document.getElementById('popupamigable');
    if (popC == 0) {
      setTimeout(() => {
        document.addEventListener('mouseout', (event) => {
          if (event.relatedTarget === null && popC == 0) {
            PopAct.hidden = false;
            popC = 2;
            this._session.setPopstate(popC);
          }
        });
      }, 5);
    } else {
      PopAct.hidden = true;
    }
  }*/
  //// ------------ POPUP------------

  // -------- paypal metodo ------------------
  // Para evitar carga de paypal antes de generar la orden
  addScript: boolean = false;
  paypalLoad: boolean = true;
  addScriptBanamex: boolean = false;


  ngAfterViewChecked(): void {
    // Nada se genera (folio, intent, voucher, botón PayPal) mientras el comprador solo está
    // eligiendo. Arranca hasta que presiona el botón de continuar (pagoIniciado).
    if (!this.pagoIniciado) return;
    let self = this;
    let statusPago = "";
    if (!this.addScript && this.metodo_pago == 3) {
      this.addPaypalScript()
        .then(() => {
          datosbol = {
            folio: this.boletos_log.folio,
            amount: this.boletos_log.amount,
          };
        })
        .then(() => { })
        .then(() => {
          const srcPaypal = (Tcomprador === 2 || Tcomprador === 3)
            ? (datosbol?.boletos ?? [])
            : [];
          clavesCarrito = srcPaypal.length > 0
            ? srcPaypal.map((b: any) => Number(b.clave)).filter((c: number) => !isNaN(c) && c > 0)
            : [];

          paypal
            .Buttons({
              commit: true,
              createOrder: async function () {
                popC = 2;
                timerSvc.iniciarPago(environment.extiendeCarritoMinutos);
                if (clavesCarrito.length > 0) {
                  await fetch(UrlExtiendeCarrito, {
                    method: 'POST',
                    headers: { 'content-type': 'application/json' },
                    body: JSON.stringify({ claves: clavesCarrito, tipo: 3 })
                  }).catch(() => {});
                }
                ////console.log("fetch");
                return fetch(Urlp, {
                  method: 'post',
                  headers: { 'content-type': 'application/json' },
                  body: JSON.stringify(datosbol),
                })
                  .then(function (res) {
                    return res.json();
                  })
                  .then(function (data) {
                    // //console.log("datos de front");
                    // //console.log(data);
                    spin.hidden = false;
                    return data.id;
                  });
              },

              onApprove: function (data, actions) {
                return actions.order.capture().then(function (details) {
                  // Show a success message to the buyer
                  //alert('Pago realizado por ' + details.payer.name.given_name + '!');
                  // //console.log("Datos de onApprove listos para procesar en back");
                  // //console.log("Folio de orden registrado en back");
                  // //console.log(details.purchase_units[0].custom_id);
                  // //console.log("Cantidad pagada");
                  // //console.log(details.purchase_units[0].amount.value);
                  // //console.log(details.payer.email_address);
                  // //console.log("Id de usuario paypal");
                  // //console.log(details.payer.payer_id);
                  // //console.log("Id orden paypal");
                  // //console.log(details.purchase_units[0].payments.captures[0].id);
                  // //console.log("todos los datos");
                  const detailsString = JSON.stringify(details);

                  //console.log(detailsString);
                  var datosorden = {
                    folio: details.purchase_units[0].custom_id,
                    nombre_cliente: details.payer.name.given_name,
                    monto: details.purchase_units[0].amount.value,
                    mensaje: details.purchase_units[0].payments.captures[0].id,
                    details: detailsString,
                  };
                  // //console.log(datosorden);
                  self.seguimientoPaypal(datosorden, detailsString);
                  fetch(Urlc, {
                    method: 'post',
                    headers: { 'content-type': 'application/json' },
                    body: JSON.stringify(datosorden),
                  })
                    .then(function (res) {
                      // Antes esto devolvía el Response tal cual (por eso cdResponse terminaba
                      // como "[object Response]"). Se lee el texto para poder revisar qué
                      // contestó el back antes de darle por buena la compra.
                      return res.text();
                    })
                    .then(function (data) {
                      var respuesta = (data || '').replace(/"/g, '').trim();

                      // El back ahora VERIFICA el pago con PayPal (VerificaPagoPayPal) y puede
                      // rechazarlo: pago no completado, monto que no cuadra, o un capture id ya
                      // usado. Antes el front no leía la respuesta y mandaba a venta-exitosa
                      // pasara lo que pasara, o sea que le decía al cliente que ya tenía su
                      // boleto aunque no fuera cierto.
                      //
                      // Se buscan los motivos de rechazo CONOCIDOS (no se valida el texto de
                      // éxito) para no romper si ese mensaje cambia: cualquier cosa que no sea
                      // un rechazo conocido se sigue tratando como compra buena.
                      var motivosRechazo = [
                        'ya se proces',          // Este pago ya se procesó
                        'ya se aplic',           // Este pago ya se aplicó a otra compra
                        'no coincide',           // El monto no coincide con el pago de PayPal
                        'No se pudo verificar',  // PayPal no respondió / captura inexistente
                        'completado en PayPal',  // El pago no está completado en PayPal
                        'Sin id de captura',
                        'No se complet',         // No se completó el pago
                      ];
                      var fueRechazado = motivosRechazo.some(function (m) {
                        return respuesta.indexOf(m) !== -1;
                      });

                      if (fueRechazado) {
                        timerSvc.finalizarPago();
                        window.location.href =
                          'error-pago?success=false&nbResponse=PagoNoVerificado&cdResponse=' +
                          encodeURIComponent(respuesta) +
                          '&referencia=' +
                          details.purchase_units[0].custom_id;
                        return;
                      }

                      //console.log(data);
                      localStorage.setItem('campaingData1', localStorage.getItem("campaingData"));
                      var Url =
                        'venta-exitosa?success=true&nbResponse=Aprobado&cdResponse=' +
                        encodeURIComponent(respuesta) +
                        '&idLiga=' +
                        details.purchase_units[0].payments.captures[0].id +
                        '&referencia=' +
                        details.purchase_units[0].custom_id +
                        '&importe=' +
                        details.purchase_units[0].amount.value +
                        '&email=' +
                        details.payer.email_address;
                      ////console.log(Url);
                      window.location.href = Url;
                    });
                });
              },
              onCancel: function (data, actions) {
                ////console.log(data);
                popC = 0;
                timerSvc.finalizarPago();
                if (Tcomprador == 3) {
                  window.location.href = 'venta-exitosa?success=false&nbResponse=Rechazado';
                } else {
                  spin.hidden = true;
                  alert('La operacion fue cancelada');
                  this.procesando = 0;
                }
              },

              onError: function (err) {
                // alert("La operacion no se completo");
                spin.hidden = false;
                this.procesando = 0;
                ////console.log(err);
                popC = 0;
                timerSvc.finalizarPago();
                window.location.href = 'venta-exitosa?success=false&nbResponse=Bloqueo';
              },
            })
            .render('#paypal-button-container');
          this.paypalLoad = false;
        });
    }

    //Metodo de pago Banamex
    if (!this.addScriptBanamex && this.metodo_pago == 4) {
      this.addPaypalScript()
        .then(() => {
          datosbol = {
            folio: this.boletos_log.folio,
            amount: this.boletos_log.amount,
          };
        })
        .then(() => { })
        .then(async () => {
          async function createOrder() {
            popC = 2;
            ////console.log("creamos orden banamex");
            return fetch(UrlBanamex, {
              method: 'post',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify(datosbol),
            })
              .then(function (res) {
                return res.json();
              })
              .then(function (data) {
                ////console.log("datos de front");
                ////console.log(data);
                ordenbanamex = data;
                //spin.hidden=false;
                return data;
              })
              .then(function (data) {
                return new Promise((resolve, reject) => {
                  if (data != null || data != undefined) {
                    return resolve('orden de banamex generada');
                  }
                });
              });
          }

          await createOrder();
        })
        .then((data) => {
          Checkout.configure({
            session: {
              id: ordenbanamex.session.id,
            },
            interaction: {
              merchant: {
                name: 'Sorteo Anahuac 2024',
                address: {
                  line1: 'Av. Universidad Anáhuac #46 Col. Lomas Anáhuac',
                  line2: ' Huixquilucan, Estado de México C.P.52786',
                },
              },
            },
          });

          function PagoBanamex() {
            spin.hidden = false;
            var scriptban = document.getElementById('ban');
            (scriptban as HTMLScriptElement).setAttribute('data-complete', 'completeCallback');
            window.completeCallback = (resultIndicator, sessionVersion) => {
              ////console.log("Operacion completada");
              ////console.log(resultIndicator);
            };
            Checkout.showLightbox();
            //Checkout.showPaymentPage()

            sessionS.setDatosOrdenBanamex(JSON.stringify(datosorden));
            sessionS.setOrdenBanamex(ordenbanamex.successIndicator);
          }

          function btncreate() {
            const container = document.getElementById('banamex-button-container');

            const button = document.createElement('button');
            button.textContent = 'Paga con Bananamex';
            button.className = 'btn btn-secondary';
            button.style.backgroundColor = '#dd741d';
            button.style.fontSize = '1.4rem';
            button.onclick = PagoBanamex;
            container.appendChild(button);
          }

          var datosorden = {
            folio: this.boletos_log.folio,
            nombre_cliente: 'Banamex',
            monto: this.boletos_log.amount,
            mensaje: 'Pago con Banamex',
          };
          var sessionS = this._session;
          btncreate();
        });
    }

    //Metodo de pago Stripe
    if (!this.addScriptStripe && this.metodo_pago == 6) {
      this.addScriptStripe = true;
      this.iniciarFlujoStripe();
    }

    //Metodo de pago OXXO
    if (!this.addScriptOxxo && this.metodo_pago == 7) {
      this.addScriptOxxo = true;
      this.iniciarFlujoOxxo();
    }

    //Metodo de pago SPEI
    if (!this.addScriptSpei && this.metodo_pago == 8) {
      this.addScriptSpei = true;
      this.iniciarFlujoSpei();
    }
  }


  async addPaypalScript() {
    if (this.metodo_pago == 3) {
      this.addScript = true;
    } else {
      this.addScriptBanamex = true;
    }

    if (this.tipos_pago == 2 || this.tipos_pago == 3) {
      await this.efectuarPagoAlterno(this.metodo_pago);
    } else {
      const genera_Orden = await this.efectuarPagoPublicoGeneral();
    }
    let promise = new Promise((resolve, reject) => {
      let scripttagElement = document.createElement('script');
      if (this.metodo_pago == 3) {
        scripttagElement.src = environment.PaypalAmbiente;
      }
      if (this.metodo_pago == 4) {
        scripttagElement.src = 'https://evopaymentsmexico.gateway.mastercard.com/checkout/version/57/checkout.js';
        //scripttagElement.setAttribute("data-complete","completeCallback");
        scripttagElement.setAttribute('data-cancel', 'cancel');
        scripttagElement.setAttribute('data-error', 'error');
        scripttagElement.setAttribute('data-beforeRedirect', 'beforeRed');
        scripttagElement.setAttribute('data-afterRedirect', 'afterRed');

        window.cancel = (payload) => {
          if (this.tipos_pago == 1) {
            window.location.href = 'error-pago?success=false&nbResponse=Rechazado';
            //////console.log("Operacion cancelada");
          } else {
            spin.hidden = true;
            //////console.log("Operacion cancelada");
            //////console.log(payload);
          }
        };
        window.error = (error) => {
          //////console.log(JSON.stringify(error));
          window.location.href = 'error-pago?success=false&nbResponse=Bloqueo';
        };
        window.beforeRed = (payload) => {
          //////console.log("Guarda datos de orden");
          Checkout.saveFormFields();
        };
        window.afterRed = (resultIndicator) => {
          //////console.log("Carga datos de orden");
          Checkout.restoreFormFields();
          //////console.log("Resultado de orden");
          //////console.log(resultIndicator);
        };
        // window.completeCallback = (resultIndicator, sessionVersion) => {
        // 	////console.log("Operacion completada");
        // 	////console.log(resultIndicator);
        // };
      }
      //		scripttagElement.src = 'https://www.paypal.com/sdk/js?client-id=sb&currency=MXN&disable-funding=credit,card';
      scripttagElement.onload = resolve;
      scripttagElement.oncancel = reject;
      scripttagElement.id = 'ban';
      document.body.appendChild(scripttagElement);
    });

    return promise;
  }

  // -------- OXXO metodo ------------------

  private ocultarSpinOxxo(): void {
    const spinEl = document.getElementById('spin') as HTMLElement | null;
    if (spinEl) spinEl.hidden = true;
  }

  async iniciarFlujoOxxo() {
    try {
      if (this.tipos_pago == 2 || this.tipos_pago == 3) {
        await this.efectuarPagoAlterno(7);
      } else {
        await this.efectuarPagoPublicoGeneral();
      }
    } catch (err) {
      console.error('[OXXO] Falló la generación de la orden de compra:', err);
      this.oxxoErrorMsg = 'No se pudo generar tu orden de compra. Intenta de nuevo.';
      this.ocultarSpinOxxo();
      this.procesando = 0;
      return;
    }
    await this.generarVoucherOxxo();
  }

  async generarVoucherOxxo() {
    if (!this.folio || this.folio == '0') {
      this.oxxoErrorMsg = 'No se pudo generar tu orden de compra. Intenta de nuevo.';
      this.ocultarSpinOxxo();
      this.procesando = 0;
      return;
    }

    const boletosSource =
      this.tipos_pago == 2 || this.tipos_pago == 3
        ? this.boletos_preAsignados.boletos
        : this.boletos;

    const primerComprador = boletosSource[0]?.comprador;
    // Flujo público general: el comprador viene en el objeto .comprador (capturado en datos-comprador).
    // Flujo app: el boleto ya está rotulado, el comprador lo resolvió el servidor (appComprador*).
    const customerName  = (
      primerComprador
        ? (`${primerComprador.nombre ?? ''} ${primerComprador.apellidos ?? ''}`).trim()
        : ''
    ) || this.appCompradorNombre || '';
    const customerEmail =
      (primerComprador?.correo_electronico ?? '')
      || this.correo
      || this.appCompradorCorreo
      || '';

    const boletosCompradores: BoletoComprador[] = boletosSource.map((b) => ({
      folio: b.folio?.toString() ?? '',
      nombre: (`${b.comprador?.nombre ?? ''} ${b.comprador?.apellidos ?? ''}`).trim() || this.appCompradorNombre || '',
      correo: b.comprador?.correo_electronico || this.appCompradorCorreo || '',
    }));

    this._stripePagoService
      .crearOxxoIntent({
        folio: this.folio,
        currency: 'mxn',
        customerEmail,
        customerName,
        boletosCompradores,
      })
      .subscribe({
        next: (res) => {
          this.oxxoVoucher = res;
          this.oxxoListo = true;
          // Detener timer y extender carrito por la duración completa del voucher OXXO
          this.st.detenerPorOxxo();
          this.extiendeCarrito(7);
          this.ocultarSpinOxxo();
          this.procesando = 0;

          sessionStorage.setItem('metodoPago', 'OXXO');
          sessionStorage.setItem('ordenDeCompra', this.folio);
          localStorage.setItem('campaingData1', localStorage.getItem('campaingData'));

          const fechaExpira = res.expiresAt
            ? new Date(res.expiresAt).toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' })
            : '';
          this.myGetService.postData({
            Folio: this.folio,
            Nombre: customerName,
            Correo: customerEmail,
            Referencia: res.referencia,
            HostedVoucherUrl: res.hostedVoucherUrl,
            FechaExpira: fechaExpira,
            Monto: res.amount
          }, 'api/BoletosWeb/EnviarVoucherOxxo').subscribe(() => {}, () => {});
        },
        error: (err) => {
          console.error('[OXXO] Falló create-oxxo-intent para folio', this.folio, err);
          this.oxxoErrorMsg = 'No se pudo generar el voucher OXXO. Intenta de nuevo.';
          this.ocultarSpinOxxo();
          this.procesando = 0;
        },
      });
  }

  ngOnDestroy(): void {
    this.st.resetModal();
  }

  // -------- SPEI metodo ------------------

  async iniciarFlujoSpei() {
    try {
      if (this.tipos_pago == 2 || this.tipos_pago == 3) {
        await this.efectuarPagoAlterno(8);
      } else {
        await this.efectuarPagoPublicoGeneral();
      }
    } catch (err) {
      console.error('[SPEI] Falló la generación de la orden de compra:', err);
      this.speiErrorMsg = 'No se pudo generar tu orden de compra. Intenta de nuevo.';
      this.ocultarSpinOxxo();
      this.procesando = 0;
      return;
    }
    await this.generarVoucherSpei();
  }

  async generarVoucherSpei() {
    if (!this.folio || this.folio == '0') {
      this.speiErrorMsg = 'No se pudo generar tu orden de compra. Intenta de nuevo.';
      this.ocultarSpinOxxo();
      this.procesando = 0;
      return;
    }

    const boletosSource =
      this.tipos_pago == 2 || this.tipos_pago == 3
        ? this.boletos_preAsignados.boletos
        : this.boletos;

    const primerComprador = boletosSource[0]?.comprador;
    // Flujo público general: el comprador viene en el objeto .comprador (capturado en datos-comprador).
    // Flujo app: el boleto ya está rotulado, el comprador lo resolvió el servidor (appComprador*).
    const customerName  = (
      primerComprador
        ? (`${primerComprador.nombre ?? ''} ${primerComprador.apellidos ?? ''}`).trim()
        : ''
    ) || this.appCompradorNombre || '';
    const customerEmail =
      (primerComprador?.correo_electronico ?? '')
      || this.correo
      || this.appCompradorCorreo
      || '';

    const boletosCompradores: BoletoComprador[] = boletosSource.map((b) => ({
      folio: b.folio?.toString() ?? '',
      nombre: (`${b.comprador?.nombre ?? ''} ${b.comprador?.apellidos ?? ''}`).trim() || this.appCompradorNombre || '',
      correo: b.comprador?.correo_electronico || this.appCompradorCorreo || '',
    }));

    this._stripePagoService
      .crearSpeiIntent({
        folio: this.folio,
        currency: 'mxn',
        customerEmail,
        customerName,
        boletosCompradores,
      })
      .subscribe({
        next: (res) => {
          this.speiVoucher = res;
          this.speiListo = true;
          this.st.detenerPorOxxo();
          this.extiendeCarrito(8);
          this.ocultarSpinOxxo();
          this.procesando = 0;

          sessionStorage.setItem('metodoPago', 'SPEI');
          sessionStorage.setItem('ordenDeCompra', this.folio);
          localStorage.setItem('campaingData1', localStorage.getItem('campaingData'));

          const fechaExpira = res.expiresAt
            ? new Date(res.expiresAt).toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' })
            : '';
          this.myGetService.postData({
            Folio: this.folio,
            Nombre: customerName,
            Correo: customerEmail,
            Clabe: res.clabe,
            BankName: res.bankName,
            Referencia: res.referencia,
            HostedInstructionsUrl: res.hostedInstructionsUrl,
            FechaExpira: fechaExpira,
            Monto: res.amount
          }, 'api/BoletosWeb/EnviarVoucherSpei').subscribe(() => {}, () => {});
        },
        error: (err) => {
          console.error('[SPEI] Falló create-spei-intent para folio', this.folio, err);
          this.speiErrorMsg = 'No se pudo generar la referencia SPEI. Intenta de nuevo.';
          this.ocultarSpinOxxo();
          this.procesando = 0;
        },
      });
  }

  formatearFechaSpei(isoDate: string | null): string {
    if (!isoDate) return '';
    const d = new Date(isoDate);
    return d.toLocaleDateString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }

  formatearClabe(clabe: string): string {
    if (!clabe || clabe.length !== 18) return clabe;
    return `${clabe.substring(0,3)} ${clabe.substring(3,3)} ${clabe.substring(6,3)} ${clabe.substring(9,3)} ${clabe.substring(12,6)}`;
  }

  cerrarSpeiYRegresar(): void {
    this.terminar();
    this.router.navigate(['compra-en-linea-boletos-sorteo-anahuac']);
  }

  cerrarOxxoYRegresar(): void {
    this.terminar();
    this.router.navigate(['compra-en-linea-boletos-sorteo-anahuac']);
  }

  formatearFechaOxxo(isoDate: string | null): string {
    if (!isoDate) return '';
    const d = new Date(isoDate);
    return d.toLocaleDateString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }

  // -------- Stripe metodo ------------------

  cargarScriptStripe(): Promise<void> {
    return new Promise((resolve, reject) => {
      if ((window as any).Stripe) {
        resolve();
        return;
      }
      let scriptTag = document.createElement('script');
      scriptTag.src = 'https://js.stripe.com/v3/';
      scriptTag.onload = () => resolve();
      scriptTag.onerror = () => reject('No se pudo cargar Stripe.js');
      document.body.appendChild(scriptTag);
    });
  }

  // Llama primero a Preventa/PreventaPublicoGeneralBanco (igual que MIT/Paypal/Banamex) para
  // obtener folio + referencia bancaria antes de cobrar con Stripe.
  async iniciarFlujoStripe() {
    try {
      if (this.tipos_pago == 2 || this.tipos_pago == 3) {
        await this.efectuarPagoAlterno(6);
      } else {
        await this.efectuarPagoPublicoGeneral();
      }
    } catch (err) {
      console.error('[Stripe] Falló la generación de la orden de compra previa al cobro:', err);
      this.stripeErrorMsg = 'No se pudo generar tu orden de compra. Intenta de nuevo.';
      spin.hidden = true;
      this.procesando = 0;
      return;
    }
    await this.iniciarPagoStripe();
  }

  async iniciarPagoStripe() {
    if (!this.folio || this.folio == '0') {
      console.error('[Stripe] No se generó folio de preventa, no se puede iniciar el cobro.');
      this.stripeErrorMsg = 'No se pudo generar tu orden de compra. Intenta de nuevo.';
      spin.hidden = true;
      this.procesando = 0;
      return;
    }

    await this.cargarScriptStripe();
    this.stripeCliente = Stripe(environment.StripePublishableKey);

    const boletosSource =
      this.tipos_pago == 2 || this.tipos_pago == 3
        ? this.boletos_preAsignados.boletos
        : this.boletos;

    const boletosCompradores: BoletoComprador[] = boletosSource.map((b) => ({
      folio: b.folio?.toString() ?? '',
      nombre: (`${b.comprador?.nombre ?? ''} ${b.comprador?.apellidos ?? ''}`).trim() || this.appCompradorNombre || '',
      correo: b.comprador?.correo_electronico || this.appCompradorCorreo || '',
    }));

    const primerComprador = boletosSource[0]?.comprador;
    const customerEmail =
      (primerComprador?.correo_electronico ?? '')
      || this.correo
      || this.appCompradorCorreo
      || '';

    this._stripePagoService
      .crearPaymentIntent({
        folio: this.folio,
        currency: 'mxn',
        customerEmail,
        boletosCompradores,
      })
      .subscribe({
        next: (res) => {
          this.stripePaymentIntentId = res.paymentIntentId;
          this.stripeElements = this.stripeCliente.elements({ clientSecret: res.clientSecret });
          const paymentElement = this.stripeElements.create('payment');
          paymentElement.mount('#stripe-payment-element');
          paymentElement.on('ready', () => {
            this.stripeFormularioCargado = true;
            spin.hidden = true;
          });
        },
        error: (err) => {
          console.error('[Stripe] Falló create-intent para folio', this.folio, err);
          this.stripeErrorMsg = 'No se pudo iniciar el cobro con tarjeta. Intenta de nuevo.';
          spin.hidden = true;
          this.procesando = 0;
        },
      });
  }

  /**
   * Punto único al picar una card. Si el total del carrito (calculado por APIs Pagos con
   * BOLETOS.COSTO) excede el límite y el límite aplica a ese método, muestra el modal y no
   * selecciona. Si la API falló, validarMonto ya resolvió como permitido.
   */
  async elegirMetodo(metodo: number): Promise<void> {
    if (this.validandoLimite || this.pagoIniciado) return;
    // Un método oculto (p. ej. MIT en liga de colaborador) no se puede elegir ni a mano.
    if (metodo === 1 && !this.habilitaMit) return;
    // Ya elegido: volver a picar la misma card no consulta de nuevo.
    if (this.metodoElegido && this.metodo_pago === metodo) {
      this.mostrarPasoConfirmar();
      return;
    }
    // Se consulta EN VIVO en cada clic (no se cachea): el costo se lee de BD en ese momento.
    this.validandoLimite = true;
    const limite = await this._stripePagoService.validarMonto(this.foliosLimite);
    this.validandoLimite = false;

    if (limite.activo && !limite.permitido && (limite.metodos || []).includes(metodo)) {
      this.limiteMontoMaximo = limite.montoMaximo;
      this.modalLimite = true;
      return;
    }

    // Solo se marca la opción: NO se genera orden ni se extiende carrito. Eso pasa en
    // continuarConMetodo, cuando el comprador presiona el botón.
    this.metodo_pago = metodo;
    this.metodoElegido = true;
    this.mostrarPasoConfirmar();
  }

  /**
   * Lleva la vista al resumen "Paso 2". En celular queda abajo de las cards; en escritorio
   * ya está a un lado y 'nearest' no mueve nada.
   */
  private mostrarPasoConfirmar(): void {
    setTimeout(() => {
      const panel = document.getElementById('paso-confirmar');
      if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 50);
  }

  /** Boletos que se pintan en el resumen: los del carrito (digital) o los de la liga (App). */
  get boletosResumen(): Array<any> {
    return (this.tipos_pago == 2 || this.tipos_pago == 3)
      ? this.boletos_preAsignados.boletos
      : this.boletos;
  }

  get sinBoletos(): boolean {
    return this.boletosResumen.length == 0;
  }

  /**
   * Botón del panel "Paso 2". Aquí (y solo aquí) empieza el pago: se genera la orden y lo
   * que siga según el método. MIT y referencia llaman directo a su preventa; Stripe, OXXO,
   * SPEI y PayPal los arranca ngAfterViewChecked en cuanto pagoIniciado es true.
   */
  continuarConMetodo(): void {
    if (!this.metodoElegido || this.pagoIniciado || this.sinBoletos) return;
    this.pagoIniciado = true;
    const esAlterno = this.tipos_pago == 2 || this.tipos_pago == 3;

    switch (this.metodo_pago) {
      case 1:
      case 2:
        if (esAlterno) {
          this.efectuarPagoAlterno(this.metodo_pago);
        } else {
          this.efectuarPagoPublicoGeneral();
        }
        break;
      case 3:
        this.seleccionarPaypal();
        break;
    }
  }

  seleccionarPaypal(): void {
    this.metodo_pago = 3;
    this.metodoElegido = true;
    this.extiendeCarrito(3);
    // extenderVisible (no iniciarPago): con PayPal el usuario NO se va del sitio — el pago
    // ocurre en una ventana emergente y sigue viendo nuestra página. Por eso el contador debe
    // quedarse a la vista, igual que con Stripe. iniciarPago marca pagoEnProceso y el HTML lo
    // esconde, que es lo correcto para MIT (ahí sí te vas a la pasarela del banco).
    this.st.extenderVisible(environment.extiendeCarritoMinutos);
  }

  private extiendeCarrito(tipo: number): void {
    // CUANDO VIENE DE LA APP NO SE EXTIENDE NADA.
    //
    // tipos_pago === 2 es "colaborador desde la App": el boleto llega aqui ya
    // rotulado, en estado 'P' y con comprador. El carrito no es lo que lo
    // protege -nadie mas se lo puede llevar, venta digital solo vende los 'N'-
    // y ponerselo hace dos danos concretos:
    //
    //   1. api/BoletosWeb/PagoBoleto pide "carrito is null", asi que la liga
    //      pagar/1 deja de leer su propio boleto y contesta "No hay boletos
    //      pendientes por pagar". Con OXXO y SPEI el carrito dura DIAS.
    //   2. En la App el boleto se comporta como si alguien mas lo estuviera
    //      comprando.
    //
    // Es la regla que ya estaba escrita para el resto del ecosistema: las ligas
    // de la App no extienden reserva. Aqui faltaba aplicarla.
    const esLigaApp = ModoLigaApp.activo() && ModoLigaApp.tipo() === 'app';
    if (this.tipos_pago === 2 || esLigaApp) return;

    const src = (this.tipos_pago === 2 || this.tipos_pago === 3)
      ? (this.boletos_preAsignados?.boletos ?? [])
      : this.boletos;
    const claves = src.map((b: any) => Number(b.clave)).filter((c: number) => !isNaN(c) && c > 0);
    if (claves.length === 0) return;
    this.myGetService.postData({ claves, tipo }, 'api/BoletosWeb/ExtiendeCarrito').subscribe(() => {}, () => {});
  }

  async confirmarPagoStripe() {
    if (!this.stripeCliente || !this.stripeElements) {
      return;
    }

    this.extiendeCarrito(6);
    // Contador VISIBLE también al confirmar (re-extiende la reserva +extiendeCarritoMinutos).
    this.st.extenderVisible(environment.extiendeCarritoMinutos);
    this.stripeErrorMsg = '';
    this.procesando = 1;
    spin.hidden = false;

    // venta-exitosa lee "referencia" (no "folio") para consultar InformacionCompraBoletos,
    // e "importe" para validar el monto recibido contra lo esperado.
    const urlExitosa =
      window.location.origin +
      '/venta-exitosa?success=true&nbResponse=Aprobado&metodoPago=STRIPE&referencia=' +
      this.folio +
      '&importe=' +
      this.total_compra;

    const { error } = await this.stripeCliente.confirmPayment({
      elements: this.stripeElements,
      confirmParams: {
        return_url: urlExitosa,
      },
      redirect: 'if_required',
    });

    if (error) {
      // La orden de compra sigue pendiente ('PP') en el back con el mismo folio: no se pierde,
      // se muestra el error y se deja reintentar el pago sin generar una nueva orden.
      console.error('[Stripe] Error al confirmar el pago:', error);
      this.stripeIntentos++;

      // Límite de intentos: al 3er intento fallido se saca al usuario a error-pago.
      if (this.stripeIntentos >= this.STRIPE_MAX_INTENTOS) {
        this.st.finalizarPago();
        spin.hidden = true;
        this.procesando = 0;
        window.location.href = 'error-pago?success=false&nbResponse=LimiteIntentos';
        return;
      }

      const intentosRestantes = this.STRIPE_MAX_INTENTOS - this.stripeIntentos;
      this.stripeErrorMsg =
        (error.message || 'No se pudo procesar tu pago. Verifica tus datos e intenta de nuevo.') +
        ` (Intento ${this.stripeIntentos} de ${this.STRIPE_MAX_INTENTOS}. Te ${intentosRestantes === 1 ? 'queda' : 'quedan'} ${intentosRestantes} ${intentosRestantes === 1 ? 'intento' : 'intentos'}.)`;
      this.st.finalizarPago();
      spin.hidden = true;
      this.procesando = 0;
    } else {
      // Stripe cobró exitosamente en su lado. Esperamos a que el webhook
      // procese la orden en nuestro backend antes de navegar a venta-exitosa.
      const confirmado = await this.esperarConfirmacionWebhook(this.folio);
      if (confirmado) {
        window.location.href = urlExitosa;
      } else {
        this.stripeErrorMsg =
          'Tu pago fue recibido por Stripe pero hubo un problema al confirmar tu orden. ' +
          'Por favor contáctanos con tu folio: ' + this.folio;
        spin.hidden = true;
        this.procesando = 0;
      }
    }
  }

  private async esperarConfirmacionWebhook(folio: string): Promise<boolean> {
    const MAX_INTENTOS = 15;
    const INTERVALO_MS = 2000;

    for (let i = 0; i < MAX_INTENTOS; i++) {
      try {
        const res = await this._stripePagoService.consultarEstadoOrden(folio).toPromise();
        if (res?.estado === 'pagado') return true;
        if (res?.estado === 'cancelado') return false;
      } catch {
        // ignorar errores de red, seguir reintentando
      }
      await new Promise(r => setTimeout(r, INTERVALO_MS));
    }
    return false; // timeout ~30 s sin confirmar
  }

  async RefBancStatus(): Promise<void> {
    let tipocompra: number;
    if (this.Paybackref == '1') {
      tipocompra = 1; //payback
    } else if (this.pkcolab != '0') {
      tipocompra = 2; // pkcolab == pasa la voz
    } else if (this.BoletosCol == '1') {
      tipocompra = 3; //Liga de colaborador
    } else if (this.BoletosCol == '0') {
      tipocompra = 4; //publico general
    }

    let boletos: any =
      this.boletos_preAsignados && this.boletos_preAsignados.boletos.length > 0
        ? this.boletos_preAsignados.boletos
        : this.boletos;

    let datos: any = {
      opc: tipocompra,
      boletos: boletos,
    };

    //////console.log('ref enviando');
    return new Promise((resolve, reject) => {
      this.myGetService.postData(datos, 'api/BoletosWeb/ReferenciaBancaria/Estatus').subscribe(
        (res) => {
          this.habilitarReferencia = res.json();
          //////console.log('response ref recibida');
          this.spinHandlerMetodoParametrizado();
          resolve();
        },
        (error) => {
          this.spinHandlerMetodoParametrizado();
        }
      );
    });
  }

  async GetMetodoParametrizado(): Promise<void> {
    let tipocompra: number;
    let nicho: string;
    if (this.Paybackref == '1') {
      tipocompra = 1; //payback
      nicho = 'payback';
    } else if (this.pkcolab != '0') {
      tipocompra = 2; // pkcolab == pasa la voz
      nicho = 'pasalavoz';
    } else if (this.BoletosCol == '1') {
      tipocompra = 3; //Liga de colaborador
      nicho = 'ligacolaborador';
    } else if (this.BoletosCol == '0') {
      tipocompra = 4; //publico general
    }

    let boletos: any =
      this.boletos_preAsignados && this.boletos_preAsignados.boletos.length > 0
        ? this.boletos_preAsignados.boletos
        : this.boletos;

    let datos: any = {
      pkmetodo: '3',
      pknicho: nicho,
      boletos: boletos,
    };

    //////console.log('paypal parametrizado enviando');
    return new Promise((resolve, reject) => {
      this.myGetService.postData(datos, 'api/BoletosWeb/Config/GetMetodoParametrizado').subscribe(
        (res) => {
          this.habilitaPaypal = res.json();
          //////console.log('response ref recibida');
          this.spinHandlerMetodoParametrizado();
          resolve();
        },
        (error) => {
          //console.log(error);
          window.location.href = 'error-pago?success=false&nbResponse=Invalido';
          this.spinHandlerMetodoParametrizado();
        }
      );
    });
  }

  /**
   * Consulta al microservicio de pagos qué métodos mostrar según la configuración
   * parametrizada (nivel colaborador → nicho → sector, filtrado por el público del flujo)
   * y aplica los flags de visibilidad. Oculta el spinner al terminar. Si el servicio falla,
   * deja visibles los métodos por defecto (MIT, PayPal, Referencia) para no bloquear la compra.
   */
  async cargarMetodosPago(): Promise<void> {
    // Público del flujo (CAT_PUBLICO_METODOS_PAGO):
    //   2 = Liga de Colaborador → liga compartida por un colaborador (BoletosCol='1').
    //   3 = Público General → compra directa en el sitio / máquina de la suerte (BoletosCol='0')
    //       y app del colaborador (BoletosCol='2').
    // Las configs marcadas "1 = Todos" aplican siempre (el backend filtra PK_PUBLICO IN (@publico, 1)).
    const publico = this.BoletosCol == '1' ? 2 : 3;

    // De que lista salen los boletos: se decide por el FLUJO (tipos_pago), igual que el
    // total en el ngOnInit. Antes se decidia por "¿hay algo en boletos_preAsignados?", y
    // ese criterio estaba mal:
    //
    //   BoletosAsignados (-> boletos_preAsignados) la llenan la LIGA DE COLABORADOR y la
    //   APP, y solo se borra al CERRAR un flujo (venta exitosa / error de pago). Si el
    //   comprador entraba a una liga, NO compraba y luego se iba a venta digital, esa lista
    //   seguia con los boletos viejos — y como tenia prioridad, se preguntaban los metodos
    //   de pago de los boletos EQUIVOCADOS. Sintoma: en venta digital salian los metodos
    //   del flujo anterior.
    //
    // El fallback a this.boletos se conserva para los flujos de liga/app en los que
    // boletos_preAsignados venga vacio: ahi el comportamiento no cambia.
    const preAsignados =
      (this.boletos_preAsignados && this.boletos_preAsignados.boletos) || [];

    const fuente =
      this.tipos_pago == 1
        ? this.boletos
        : (preAsignados.length > 0 ? preAsignados : this.boletos);

    const boletos = (fuente || []).map((b: any) => ({
      folio: (b.folio ?? '').toString(),
      claveColaborador: Number(b.clave_colaborador) || 0,
      claveSorteo: Number(b.clave_sorteo) || 0,
    }));

    // Folios para validar el límite por transacción al picar una card (ver elegirMetodo).
    this.foliosLimite = boletos.map((b) => b.folio);

    // Liga de colaborador / venta externa: si alguno de estos boletos paso por la liga y
    // environment.metodosPagoLigaColaborador.mit es false, MIT no sale aunque SGSA lo permita.
    const mitPermitido = MetodosLigaColaborador.mitPermitido(this.foliosLimite);

    return new Promise((resolve) => {
      this._stripePagoService.getMetodosPago({ publico, boletos }).subscribe(
        (res) => {
          const f = res && res.flags ? res.flags : ({} as any);
          this.habilitaMit = !!f.mit && mitPermitido;
          this.habilitarReferencia = !!f.referencia;
          this.habilitaPaypal = !!f.paypal;
          this.habilitaStripe = !!f.stripe;
          this.habilitaOxxo = !!f.oxxo;
          this.habilitaSpei = !!f.spei;
          if (spin) spin.hidden = true;
          resolve();
        },
        () => {
          // Fallback ante error de red: dejar los métodos por defecto visibles.
          this.habilitaMit = mitPermitido;
          this.habilitaPaypal = true;
          this.habilitarReferencia = true;
          this.habilitaStripe = false;
          this.habilitaOxxo = false;
          this.habilitaSpei = false;
          if (spin) spin.hidden = true;
          resolve();
        }
      );
    });
  }

  public spinHandlerMetodoParametrizado(): void {
    if (this.spinhandler == 1) {
      spin.hidden = true;
    } else {
      this.spinhandler++;
    }
  }

  seguimientoPaypal(datosorden: { folio: string; nombre_cliente: any; monto: string; mensaje: any; }, details?: string) {
    let respuesta;
    sessionStorage.setItem('metodoPago', 'PAYPAL');
    sessionStorage.setItem('ordenDeCompra', datosorden.folio);
    let tipoP = sessionStorage.getItem('TiposPago');
    let tipoPF = parseInt(tipoP, 10);

    //console.log(tipoPF);
    if (tipoPF == 2 || tipoPF == 3) {
      sessionStorage.setItem('paginaclick', '/forma-pago - directo');
      this._seguimiento.addSeguimiento(JSON.parse(sessionStorage.getItem('BoletosAsignados')), details).subscribe(a => {
        //console.log(a);
        respuesta = a;
        const pk_seguimiento = respuesta.pk1;
        //console.log(pk_seguimiento);
        sessionStorage.setItem('pk_seguimiento', pk_seguimiento);
      },
        err => {

        });
    } else {
      //updatear cuando ya esta creado el seguimiento
      sessionStorage.setItem('paginaclick', '/forma-pago');
      this._seguimiento.updateSeguimiento(details).subscribe(a => {
        //console.log(a);
      },
        err => {

        });
    }
  }




}

